module.exports = __webpack_public_path__ + "assets/img/btn-view-info-4655d7a2.png";